import { Component } from "react";
import { Link } from "react-router-dom";
import{FaTrash} from 'react-icons/fa';

export default class CartDetials extends Component{

    render(){
        return(<div className="px-10">
            <h1 className="text-center text-2xl py-8 text-slate-600">Your Cart</h1>
            <div className="flex flex-col md:flex-row justify-around mt-10">
                <table className="border-collapse w-[65%] mx-3">
                    <thead className="border-b-2">
                        <tr className="px-5">
                            <td className="px-2">PRODUCTS</td>
                            <td className="px-2">PRICE</td>
                            <td className="px-2">QUANTITY</td>
                            <td className="px-2">TOTAL</td>
                            <td className="px-2"></td>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.cart.cart && this.props.cart.cart.map(item=>
                            <tr className="px-5 border-b-2" key={item.product.id}>
                                <td className="px-2 flex justify-center items-center h-28">
                                    <img src={item.product.images[0]} alt="/" className="w-12 mx-2"/>
                                    {item.product.title}
                                </td>
                                <td className="px-2">${item.product.price}</td>
                                <td className="px-2">{item.quantity}</td>
                                <td className="px-2">${item.quantity * item.product.price}</td>
                                <td className="px-2"><FaTrash onClick={()=>this.props.removeFromCard(item.product)}/></td>
                            </tr>
                            )}
                    </tbody>
                </table>
                <div className="rounded-sm w-[35%] bg-slate-100 shadow-sm p-8 mx-5">
                    <h1 className="border-b-2 border-slate-400 p-2 text-2xl">Order Summary</h1>
                    <table className="w-full">
                        <tbody className="border-b-2 border-slate-400">
                            <tr>
                                <td className="px-2 py-3">Subtotal</td>
                                <td className="py-3">${this.props.prices}</td>
                            </tr>                        
                            <tr>
                                <td className="px-2 py-3">Shipping</td>
                                <td className="py-3">Free</td>
                            </tr>  
                        </tbody> 
                        <tfoot>
                            <tr>
                                <td className="px-2 py-3">TOTAL</td>
                                <td className="py-3">${this.props.prices}</td>
                            </tr>
                        </tfoot>                    
                    </table>
                    <Link to="/shop/product" className="text-white"><div className="bg-green-600 text-center py-2 my-2 rounded-md">CHECKOUT</div></Link>
                </div>
            </div>
        </div>)
    }
} 